<template>
<div id="header" class="header m-visible">
    <div id="header-inner-top" class="pdt-10">
        <div class="goto-back">
            <a href="javascript: void(0);" @click.prevent="disDetailHeader()">뒤로가기</a>
        </div>
        <div class="main-tit pdt-15" style="width:100%;">
            <h2 class="subtitle">데이터 강남</h2>
        </div>
    </div>
</div>

</template>
<script>
import {mapGetters} from "vuex";
import {$_TYPE, $_CD} from '@/confs/common.const';
export default {
    computed: {
        ...mapGetters({
            isDetail: 'getIsDetail',
            selectedIndicator: 'getSelectedIndicator',
        }),
        detailTitle() {
            let title = '';
            if(typeof this.selectedIndicator !== $_TYPE.UNDEF) {
                title = this.selectedIndicator.idxDispNm;
            }
            return title;
        },
    },
    methods: {
        disDetailHeader() {
            this.$store.dispatch("SET_IS_DETAIL", false);
        },
    }
}
</script>
